module.exports = __webpack_public_path__ + "img/confirmarcartao.a54073da.svg";